
// Universidad Catolica - front publico del catalogo.
// Local: nginx sirve C:/laragon/www/emprendimientos en el puerto 8091.
const server = {
    baseURL: 'https://sospy.org/s1_catalogos_catolica/public/',   // <- PRODUCCION (activa)
    // baseURL: 'http://localhost:8091/catalogo_catolica/s1_catalogos_catolica/public/',   // <- local
    // --- otros proyectos ---
    // baseURL: 'https://sospy.org/s1_catalogos/public/',
    // baseURL: 'https://sospy.org/s1_catalogos_v2/public/',
    // baseURL: 'https://emprendimientosvirtuales.com.py/s1_cerro/public/',
    // baseURL: 'https://local.quattropy.com/emprendimiento/s1/public/',
    urlProducto: ''
}

export default server;
